import { ComponentPropsWithoutRef, ReactNode } from 'react';
import { Typography } from 'Components/atoms';
import classNames from 'classnames';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import ChatTableWithChart from './ChatTableWithChart';
import './styles.scss';

const markdownComponents = {
    table: ({ children, ...props }: ComponentPropsWithoutRef<'table'> & { children?: ReactNode }) => (
        <ChatTableWithChart {...props}>{children}</ChatTableWithChart>
    ),
};

interface ChatMessageProps {
    message: string;
    sender: 'user' | 'ai';
}
const ChatMessage = ({ message, sender }: ChatMessageProps) => {
    const isAI = sender === 'ai';

    return (
        <div className={classNames('chat-message', `chat-message--${sender}`)}>
            {isAI && (
                <div className="chat-message__avatar">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path
                            d="M8 1l1.5 4.5L14 7l-4.5 1.5L8 13l-1.5-4.5L2 7l4.5-1.5L8 1z"
                            fill="currentColor"
                        />
                    </svg>
                </div>
            )}
            <div className="chat-message__content">
                {isAI ? (
                    <div className="chat-message__markdown body5">
                        <Markdown remarkPlugins={[remarkGfm]} components={markdownComponents}>
                            {message}
                        </Markdown>
                    </div>
                ) : (
                    <Typography variant="body5" style={{ margin: 0 }}>
                        {message}
                    </Typography>
                )}
            </div>
        </div>
    );
};

export default ChatMessage;
